import { CSSProperties, ReactNode } from 'react';

export interface __ButtonProps {
    onClick?: () => Promise<any | undefined> | void;
    type?: __ButtonTypes;
    style?: CSSProperties;
    disabled?: boolean;
    href?: string;
    className?: string;
    children?: ReactNode;
}

export enum __ButtonTypes {
    filled = 'filled',
    outline = 'outline',
}
